import { CREDITO_FISCAL_TYPES } from "../constants/credito-fiscal.types";
import { ActionCF, CreditoFiscal, StateCF } from "../interfaces/credito-fiscal.interfaces";

const initialState: CreditoFiscal = {
    formCliente: {
        granContribuyente: false,
        fecha: new Date().toISOString().split('T')[0],
        propina: false,
        tipoDocumento: '36',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',
    
        datosSucursal: [],
        datosDocumento: [],
    
        sucursal: '',
        serie:'',
        loadedSucursal: false,
    },

    formClienteFeles: {
        esClienteFeles: false,
        tipoTransaccion: '00',
        valorTransaccion: '',
        documento: '',
        idBanco: '',
        numAutorizacion: '',
    },
    errorsClienteFeles: {
        esClienteFeles: false,
        tipoTransaccion: '',
        valorTransaccion: '',
    },

    errorsCliente: {
        granContribuyente: false,
        fecha: '',
        propina: false,
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',
        chipsEmail: [],
    
        datosSucursal: null,
        datosDocumento: null,
    
        sucursal: '',
        serie:'',
    },

    productos: [],
    formProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        noSujeto: false,
        unidadMedida: '59'
    },

    errorsProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: '',
        descuento: '',
        servicio: false,
        exento: false,
        noSujeto: false,
        unidadMedida: ''
    },
    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,
    modal_notaRemision: false,
    modal_asociarClienteFeles: false,

    notasRemisionAsociadas: [],
    notasRemisionEncontradas: [],

    clienteEncontrado: null,
    productoEdit: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        noSujeto: false, 
        unidadMedida: ''
    },
    productoIndex: null,

    calculosGenerales: {
        operaciones: '',
        retencionRenta: '',
        iva: '',
        ivaPercibido: '',
        ivaRenetido: '',
    },

    calculosProducto: {
        neto: '',
        subtotal: '',
        descuento: '',
        total: '',
        iva: ''
    },

    view: 'Formularios',
    
    response_Emitir: null,
    response_QRcode: '',
    sucursales: [],
    documentos: [],
    tableProductos: [],
    retencionRenta: false,

    loader_notasRemision: false
}

const creditoFiscalReducer = (
    state: CreditoFiscal = initialState,
    action: ActionCF
): StateCF => {
    switch (action.type) {
        case CREDITO_FISCAL_TYPES.CCF_SET_FORM_CLIENTE:
            return {...state, formCliente: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_FORM_PRODUCTO:
            return {...state, formProducto: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_FORM_CLIENTE_FELES:
            return {...state, formClienteFeles: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_HANDLE_ERRORS_CLIENTE:
            return {...state, errorsCliente: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_HANDLE_ERRORS_PRODUCTO:
            return {...state, errorsProducto: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_HANDLE_ERRORS_CLIENTE_FELES:
            return {...state, errorsClienteFeles: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_VIEW:
            return {...state, view: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_PRODUCTOS:
            return {...state, productos: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_PRODUCTO_EDIT:
            return {...state, productoEdit: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_PRODUCTO_INDEX:
            return {...state, productoIndex: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_EDITAR_PRODUCTO:
            return {...state, modal_editar: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ELIMINAR_PRODUCTO:
            return {...state, modal_eliminar: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_QUITAR_TODO:
            return {...state, modal_quitarTodo: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_EMITIR:
            return {...state, modal_emitir: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_EMITIDO:
            return {...state, modal_emitido: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_MAS_OPCIONES:
            return {...state, modal_masOpciones: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ENVIAR_CORREO:
            return {...state, modal_enviarCorreo: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ANULAR:
            return {...state, modal_anular: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_ANULADO:
            return {...state, modal_anulado: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_IMPRIMIR:
            return {...state, modal_imprimir: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_CALCULOS_GENERALES:
            return {...state, calculosGenerales: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_RESTART_FORM_PRODUCTO:
            return {...state, formProducto: initialState.formProducto}
        case CREDITO_FISCAL_TYPES.CCF_SET_QR_CODE:
            return {...state, response_QRcode: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_RESPONSE_EMITIR:
            return {...state, response_Emitir: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_CLIENTE_ENCONTRADO:
            return {...state, clienteEncontrado: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_MODAL_CLIENTE_ENCONTRADO:
            return {...state, modal_clienteEncontrado: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_CALCULOS_PRODUCTO:
            return {...state, calculosProducto: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_TABLE_PRODUCTOS:
            return {...state, tableProductos: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_SET_RETENCION_RENTA:
            return {...state, retencionRenta: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_NOTA_REMISION:
            return {...state, modal_notaRemision: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_NOTAS_REMISION_ASOCIADAS:
            return {...state, notasRemisionAsociadas: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_NOTAS_REMISION_ENCONTRADAS:
            return {...state, notasRemisionEncontradas: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_LOADER_NOTAS_REMISION:
            return {...state, loader_notasRemision: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_ACTIVE_ASOCIAR_FELES:
            return {...state, modal_asociarClienteFeles: action.payload}
        case CREDITO_FISCAL_TYPES.CCF_RESTART_ALL:
            return {...initialState, productos: [], formCliente: initialState.formCliente}
        default:
            return state;
    }
}

export default creditoFiscalReducer;